import config from "@/config";

type GtagType = (command: string, eventName: string, eventParams?: Record<string, any>) => void;

export const gtagTrackEvent = (
  eventName: string,
  eventParams?: { event_category: string; event_action: string } | Record<string, any>
): void => {
  if (typeof (window as any).gtag === "function") {
    ((window as any).gtag as GtagType)("event", eventName, eventParams);
  }
};

export const gtagTrackEventScrile = (
  eventName: string,
  eventParams?: { event_category: string; event_action: string } | Record<string, any>
): void => {
  if (typeof (window as any).gtag === "function" && config.scrileGtagId) {
    ((window as any).gtag as GtagType)("event", eventName, {
      send_to: config.scrileGtagId,
      ...eventParams,
    });
  }
};

class YmEventsScrile {
  private readonly ymId = 56757517;

  private readonly _ym = (eventName: string) => {
    if (typeof (window as any).ym === "function") {
      (window as any).ym(this.ymId, "reachGoal", eventName);
    }
  };

  public purchaseFromBalance = () => {
    this._ym("purchaseFromBalance");
  };
  public paymentSubscribe = () => {
    this._ym("paymentSubscribe");
  };
  public paymentPurchase = () => {
    this._ym("paymentPurchase");
  };
  public signupWithoutCode = () => {
    this._ym("signupWithoutCode");
  };
  public signupCodeSubmit = () => {
    this._ym("signupCodeSubmit");
  };
}
export const yMetrics = new YmEventsScrile();
